import { OfferDiscountTypeEnumV2 } from '@redteclab/api/clients/bully'

import store from 'shared/store'
import { getLegalSupNote } from 'views/components/organisms/Cart/ProductListCart/SellerPromotionBanner/GetSellerPromotionNotification'
import { MARKETPLACE_DISCOUNT_MODAL_CONTAINER_ID } from 'views/components/organisms/MarketPlaceDiscountModal/names'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'

import { OPEN_MARKETPLACE_DISCOUNT_MODAL } from './clientsideHook'

const mountMarketPlaceDiscountModalContainer = async () => {
  const marketPlaceDiscountButtons = document.querySelectorAll(
    `[data-clientside-hook*="${OPEN_MARKETPLACE_DISCOUNT_MODAL}"]`
  )
  const modal = document.getElementById(MARKETPLACE_DISCOUNT_MODAL_CONTAINER_ID)

  if (!modal) {
    return
  }

  const {
    publicConfig: { locale, tenant },
  } = store.getPublicRuntimeConfig()

  const legalSufixTenantNumber = getLegalSupNote(tenant)

  const i18n = await loadCatalogs(locale)

  const marketPlaceDiscountModalContainer = await import(
    './MarketPlaceDiscountModalContainerWithHydration.js'
  )

  marketPlaceDiscountButtons.forEach(button => {
    const discountConditionValue = button.getAttribute(
      'data-discount-condition-value'
    )
    const discountValue = button.getAttribute('data-discount-value')
    const discountType = button.getAttribute('data-discount-type')
    const marketplaceDiscountModalTitleElement = document.getElementById(
      'marketplace-discount-modal__Modal__title'
    )

    button.addEventListener('click', () => {
      const container = marketPlaceDiscountModalContainer.default({
        discountConditionValue,
        discountValue,
        discountType,
        container: modal,
        i18n,
      })

      if (marketplaceDiscountModalTitleElement) {
        const modalTitle =
          discountType === OfferDiscountTypeEnumV2.FreeItems
            ? i18n._(
                'seller.promotion.sellerBanner.title.minimumSameItemQuantity.freeItems',
                {
                  formattedConditionAmount: discountConditionValue,
                  formattedDiscountAmount: `${
                    Number(discountConditionValue) - Number(discountValue)
                  }`,
                  sup: `<sup>${legalSufixTenantNumber}</sup>`,
                }
              )
            : i18n._(
                'seller.promotion.sellerBanner.title.minimumSameItemQuantity.total',
                {
                  sup: `<sup>${legalSufixTenantNumber}</sup>`,
                }
              )

        marketplaceDiscountModalTitleElement.innerHTML = modalTitle
      }

      container.show()
    })
  })
}

export default mountMarketPlaceDiscountModalContainer
